import React, {useState} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Tag.module.scss';

export const Tag = ({children, value, closable, onClick}) => {
  const [visible, setVisible] = useState(true);

  const handleClick = () => {
    setVisible(false);
    if (onClick) onClick(value || children);
  };

  return (
    <span className={cn(styles.wrap, {[styles.hidden]: !visible})}>
      {children} {closable &&
    <button className={styles.button} onClick={handleClick}>
      <span className={styles.buttonLine} />
      <span className={styles.buttonLine} />
    </button>}
    </span>
  );
};

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.string,
  closable: PropTypes.bool,
  onClick: PropTypes.func,
};

Tag.defaultProps = {
  value: null,
  closable: false,
  onClick: () => null,
};
